import type { FaireProductEntity } from "../../entity_types/product";

export const p_bty26xphyc: FaireProductEntity = {
  token: "p_bty26xphyc",
  type: "product",
  name: "Single Origin Espresso",
  brandToken: "b_cgzjcth7hb",
  brandName: "Four Barrel Coffee",
  imageUrl: "https://cdn.faire.com/fastly/05352394c73320496f3fd61978369bd49e81331ef992606ab810c9b9d3731575.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/816e08e014034d3a17265ef4fe4124e2f19f178aaa4ed9b80a1c7123693adbcd.png"
  ],
  priceDollars: 13.85,
  description: "Currently our Kenya Kiamwangi - just roasted for espresso — peach gummies, dried apricot, lemon, jasmine florality and crystal clear, sparkling acidity.\n\nThis is our first year buying from the Kiamwangi factory in Nyeri, and this lot from the Iria-ini Cooperative, composed of 550 farmers, blew us away with its gorgeously classic Kenya profile. Known for allowing their coffees to mature slowly, as well as for their deep red volcanic soil, Kiamwangi's cherries are extremely dense, creating a complex sparkling cup: peach gummies, dried apricot, lemon, jasmine florality and crystal clear, sparkling acidity.",
  tags: [],
  msrpDollars: 21.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:48.206Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
